export const Logo = () => (
    <a href="#top" data-testid="logo-link" className="group flex items-center">
        <span className="rounded-xl bg-white px-3 py-1.5 transition-transform duration-200 group-hover:-rotate-2">
            <img
                src="/quikpik-wordmark.png"
                alt="Quikpik logo"
                className="h-10 w-auto"
                data-testid="logo-image"
            />
        </span>
    </a>
);

export const Nav = () => (
    <header className="sticky top-0 z-50 border-b border-[#1f1f1f] bg-[#111111]/90 backdrop-blur-md">
        <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4" data-testid="main-nav">
            <Logo />
            <span
                data-testid="nav-coming-soon-pill"
                className="rounded-full border border-[#2a2a2a] bg-[#1a1a1a] px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#a1a1aa]"
            >
                Launching soon
            </span>
        </nav>
    </header>
);
